import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Car = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M15.334 12.044H14a.333.333 0 1 1 0-.667h1v-3a.333.333 0 0 0-.333-.333h-3.333a.333.333 0 0 1-.314-.22L9.847 4.598a.333.333 0 0 0-.313-.22H4.467a.333.333 0 0 0-.313.22L2.98 7.825a.333.333 0 0 1-.314.22H1.334a.333.333 0 0 0-.333.332v3h1a.333.333 0 1 1 0 .667H.667a.333.333 0 0 1-.333-.333V8.377a1 1 0 0 1 1-1h1.1L3.528 4.37a1.004 1.004 0 0 1 .94-.658h5.066a1.003 1.003 0 0 1 .94.658l1.093 3.008h3.1a1 1 0 0 1 1 1v3.334a.333.333 0 0 1-.333.333Z" />
      <path d="M10.666 12.044H5.333a.333.333 0 1 1 0-.667h5.333a.333.333 0 1 1 0 .667Z" />
      <path d="M3.668 9.71a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 3.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667ZM12.334 9.71a2 2 0 1 1 0 4.001 2 2 0 0 1 0-4Zm0 3.334a1.334 1.334 0 1 0 0-2.667 1.334 1.334 0 0 0 0 2.667ZM11.334 8.044H2.667a.333.333 0 1 1 0-.667h8.667a.333.333 0 1 1 0 .667Z" />
      <path d="M7.001 8.044a.333.333 0 0 1-.333-.333V4.044a.333.333 0 0 1 .667 0v3.667A.333.333 0 0 1 7 8.044Z" />
    </svg>
  );
};

Car.category = 'product-category';

Car.displayName = 'Car';
